<template>
  <UiSelect
    v-if="options.length"
    :model-value="currentPage"
    class="topbar-location topbar__select"
    item-id="value"
    item-text="name"
    :options="options"
    custom-options
    icon="location"
    input-fit-width
    @update:model-value="handleSelect"
  >
    <UiSelectOption
      v-for="option in options"
      :key="option.value"
      :option="option"
      class="topbar-location__option"
    >
      <UiIcon icon="location" />
      {{ option.name }}
      <UiIcon v-if="currentPage === option.value" icon="checkmark" />
    </UiSelectOption>
  </UiSelect>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useMenus } from '~/composables';

const { menuTop } = useMenus();

const options = computed(() =>
  menuTop.value.map((el) => ({
    name: el.name,
    value: el.url,
  })),
);
const currentPage = computed(() => {
  if (!import.meta.client) return '';
  return options.value.find((option) => option.value === window.location.origin)
    ?.value;
});

const handleSelect = (e: any) => {
  window.location.replace(e);
};
</script>

<style lang="scss" scoped>
.topbar-location {
  &__option {
    min-width: 176px;
    display: flex;
    align-items: center;
    padding: 12px 16px;
    font-size: 11px;
    font-weight: 700;
    line-height: 11px;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    svg {
      color: #3a5199;
      flex-shrink: 0;
      &:nth-child(1) {
        margin-right: 4px;
        width: 20px;
        height: 20px;
      }
      &:nth-child(2) {
        margin-left: auto;
        width: 16px;
        height: 16px;
      }
    }
  }
}
</style>
